import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../core/api-config';
import { CourseModel, CustomerProfileModel, OrderModel, TagModel } from '../../core/models';
import { VOCCourseModel } from 'src/app/core/VOCCourseModel';
import { PagedResponseModel } from 'src/app/core/PagedResponseModel';
import { ShortCourseOrderModel } from 'src/app/core/ShortCourseOrderModel';
import { VOCCoursePublicModel } from 'src/app/components/admin-voc-course-detail/admin-voc-course-detail.component';
import { HomeCourseContentModel } from 'src/app/core/HomeCourseContentModel';
import { StateModel } from 'src/app/core/StateModel';
import { CourseDownloadModel } from 'src/app/core/CourseDownloadModel';

// Admin platform service.
@Injectable({ providedIn: 'root' })
export class AdminService {
  // Inject HTTP.
  constructor(private http: HttpClient) { }

  getDashboard(): Observable<any> { return this.http.get<any>(`${ApiConfig.baseUrl}/admin/dashboard`); }

  getCourses(stateCode: string =""): Observable<CourseModel[]> {
    return this.http.get<CourseModel[]>(`${ApiConfig.baseUrl}/admin/courses`,{
      params: {
        stateCode: stateCode.toString()
      }
    });
  }

  getCourseDetail(id: number): Observable<CourseModel> { return this.http.get<CourseModel>(`${ApiConfig.baseUrl}/admin/courses/${id}`); }
  saveCourse(model: CourseModel): Observable<any> { return this.http.post<any>(`${ApiConfig.baseUrl}/admin/courses`, model); }
  saveCluster(model: CourseModel): Observable<CourseModel> { return this.http.post<CourseModel>(`${ApiConfig.baseUrl}/admin/courses/clusters`, model); }
  getClusterDetail(id: number): Observable<CourseModel> { return this.http.get<CourseModel>(`${ApiConfig.baseUrl}/admin/courses/clusters/${id}`); }
  deleteCourse(id: number): Observable<any> { return this.http.delete<any>(`${ApiConfig.baseUrl}/admin/courses/${id}`); }
  getTags(action: string): Observable<TagModel[]> {
    return this.http.get<TagModel[]>(`${ApiConfig.baseUrl}/admin/tags`, {
      params: {
        action
      }
    });
  }
  saveTag(model: TagModel): Observable<any> { return this.http.post<any>(`${ApiConfig.baseUrl}/admin/tags`, model); }
  deleteTag(id: number): Observable<any> { return this.http.delete<any>(`${ApiConfig.baseUrl}/admin/tags/${id}`); }
  getCustomers(): Observable<CustomerProfileModel[]> { return this.http.get<CustomerProfileModel[]>(`${ApiConfig.baseUrl}/admin/customers`); }
  saveCustomer(model: CustomerProfileModel): Observable<any> { return this.http.post<any>(`${ApiConfig.baseUrl}/admin/customers`, model); }
  getAdmins(): Observable<any[]> { return this.http.get<any[]>(`${ApiConfig.baseUrl}/admin/admin-users`); }
  saveAdmin(model: any): Observable<any> { return this.http.post<any>(`${ApiConfig.baseUrl}/admin/admin-users`, model); }
  getOrders(): Observable<OrderModel[]> { return this.http.get<OrderModel[]>(`${ApiConfig.baseUrl}/admin/orders`); }
  getUnifiedCartOrders(accessToken: string): Observable<OrderModel[]> {
    return this.http.get<OrderModel[]>(`${ApiConfig.baseUrl}/unified-cart/orders`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
  }

  saveVocForm(
    model: VOCCourseModel,
    action: string
  ): Observable<any> {
    return this.http.post<any>(
      `${ApiConfig.baseUrl}/admin/SetVOCCourseFrom?action=${encodeURIComponent(action)}`,
      model
    );
  }
  updateTagRanking(model: any[]): Observable<any> {
    return this.http.post(
      `${ApiConfig.baseUrl}/admin/UpdateTagRanking`,
      model
    );
  }

  getVOCCourses(action: string, pageNo: number, pageSize: number): Observable<PagedResponseModel<VOCCourseModel>> {
    return this.http.get<PagedResponseModel<VOCCourseModel>>(
      `${ApiConfig.baseUrl}/admin/GetVOCCourseFormsList`,
      {
        params: {
          action,
          pageNo: pageNo.toString(),
          pageSize: pageSize.toString()
        }
      }
    );
  }


  getShortCourseOrderList(
    action: string,
    pageNo: number,
    pageSize: number
  ): Observable<PagedResponseModel<ShortCourseOrderModel>> {

    const params = new HttpParams()
      .set('action', action)
      .set('pageNo', pageNo.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<PagedResponseModel<ShortCourseOrderModel>>(
      `${ApiConfig.baseUrl}/admin/GetShortCourseOrderList`,
      { params }
    );
  }



  getVOCCoursePublicList(action: string, pageNo: number, pageSize: number): Observable<PagedResponseModel<VOCCoursePublicModel>> {
    return this.http.get<PagedResponseModel<VOCCoursePublicModel>>(`${ApiConfig.baseUrl}/admin/GetVOCCoursePublicList`,
      {
        params: {
          action,
          pageNo: pageNo.toString(),
          pageSize: pageSize.toString()
        }
      }
    );
  }

  saveVOCCoursePublic(
    model: VOCCoursePublicModel,
    action: string
  ): Observable<any> {
    return this.http.post<any>(
      `${ApiConfig.baseUrl}/admin/SetVOCCoursePublic?action=${encodeURIComponent(action)}`,
      model
    );
  }




  // Get UOC course list.
  getXCourseList(type: string, stateCode: string=""): Observable<any> {
     let params = new HttpParams()
      .set('action', type).set('stateCode', stateCode);
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXCourseList`,{params}
    );
  }



  // Get UOC course list.
  GetXCourseListByType(action: string, type: string, search: string = "", searchKey: string = "", isActive: boolean | null = null, stateCode: string = ""): Observable<any> {
    let params = new HttpParams()
      .set('action', action).set('type', type).set('search', search).set('searchKey', searchKey).set('stateCode', stateCode);

    if (isActive !== null) {
      params = params.set(
        'isActive',
        String(isActive)
      );
    }
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXCourseListByType`,
      { params }
    );
  }




  // Get UOC course list.
  GetXCourseFullDetails(courseId: number): Observable<any> {
    const params = new HttpParams()
      .set('courseId', courseId);

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXCourseFullDetails`,
      { params }
    );

  }


  // ============================================================
  // CREATE SHORT COURSE MANUALLY
  // ============================================================

  CreateXCourse(
    model: any
  ): Observable<any> {

    return this.http.post<any>(
      `${ApiConfig.baseUrl}/admin/CreateXCourse`,
      model
    );
  }


  // ============================================================
  // DELETE SHORT COURSE
  // ============================================================

  DeleteXCourse(
    courseId: number
  ): Observable<any> {

    return this.http.delete<any>(
      `${ApiConfig.baseUrl}/admin/DeleteXCourse/${courseId}`
    );
  }


  // ============================================================
  // UPDATE FULL COURSE DETAILS
  // ============================================================

  UpdateXCourseDetails(
    model: any
  ): Observable<any> {

    return this.http.put<any>(
      `${ApiConfig.baseUrl}/admin/UpdateCourseDetails`,
      model
    );
  }


  // get Course List With Details
  getXCourseListWithDetails(action: string, type: string): Observable<any> {
    const params = new HttpParams()
      .set('action', action).set('type', type);

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXCourseListWithDetails`,
      { params }
    );


  }


  // Get VOC course list.
  getXVOCList(action: string): Observable<any> {
    const params = new HttpParams()
      .set('action', action);
    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXVOCList`, { params }
    );
  }


  // Get VOC occurrences by VOC Id.
  getXVOCOccuranceList(fkVOCId: number): Observable<any> {
    const params = new HttpParams()
      .set('fkVOCId', fkVOCId);

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXVOCOccuranceList`,
      { params }
    );
  }


  // Get Course occurrences by Course Id.
  getXCourseOccuranceList(fkCourseId: number): Observable<any> {
    const params = new HttpParams()
      .set('fkCourseId', fkCourseId);

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXCourseOccuranceList`,
      { params }
    );
  }


  // Insert / Update / Delete / Approve enquiry.
  setXEnquiry(
    model: any,
    action: string
  ): Observable<string> {

    const params =
      new HttpParams()
        .set(
          'action',
          action
        );

    return this.http.post(
      `${ApiConfig.baseUrl}/admin/SetXEnquiry`,
      model,
      {
        params,
        responseType: 'text'
      }
    );
  }

  setXBooking(
    model: any,
    action: string
  ): Observable<string> {

    const params =
      new HttpParams()
        .set(
          'action',
          action
        );

    return this.http.post(
      `${ApiConfig.baseUrl}/admin/SetXBooking`,
      model,
      {
        params,
        responseType: 'text'
      }
    );
  }



  // Get enquiry list with paging.
  getXEnquiryList(
    action: string,
    pageNo: number,
    pageSize: number,
    isApproved: boolean | null = null,
    isActive: boolean | null = null,
    selectedEnquiryType: string = ""
  ): Observable<any> {

    let params =
      new HttpParams()
        .set('action', action)
        .set('pageNo', pageNo.toString())
        .set('selectedEnquiryType', selectedEnquiryType)
        .set('pageSize', pageSize.toString());


    if (isApproved !== null) {
      params = params.set(
        'isApproved',
        isApproved.toString()
      );
    }


    if (isActive !== null) {
      params = params.set(
        'isActive',
        isActive.toString()
      );
    }


    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXEnquiryList`,
      { params }
    );
  }


  approveXEnquiry(enquiryId: number, reviewedBy: number, approvalTrainingDate: string): Observable<string> {

    const params =
      new HttpParams()
        .set('enquiryId', enquiryId.toString())
        .set('reviewedBy', reviewedBy.toString()).
        set('approvalTrainingDate', approvalTrainingDate.toString());
    return this.http.post(
      `${ApiConfig.baseUrl}/admin/ApproveXEnquiry`,
      null,
      {
        params,
        responseType: 'text'
      }
    );
  }


  sendGeneralRegistrationForm(enquiryId: number, reviewedBy: number, approvalTrainingDate: string): Observable<string> {

    const params =
      new HttpParams()
        .set('enquiryId', enquiryId.toString())
        .set('reviewedBy', reviewedBy.toString()).
        set('approvalTrainingDate', approvalTrainingDate.toString());
    return this.http.post(
      `${ApiConfig.baseUrl}/admin/SendGeneralRegistrationForm`,
      null,
      {
        params,
        responseType: 'text'
      }
    );
  }

  ApproveXBooking(enquiryId: number, reviewedBy: number, approvalTrainingDate: string, actionType: string): Observable<string> {

    const params =
      new HttpParams()
        .set('enquiryId', enquiryId.toString())
        .set('reviewedBy', reviewedBy.toString()).
        set('approvalTrainingDate', approvalTrainingDate.toString()).
        set('actionType', actionType);
    return this.http.post(
      `${ApiConfig.baseUrl}/admin/ApproveXBooking`,
      null,
      {
        params,
        responseType: 'text'
      }
    );
  }

  getApprovedXEnquiry(enquiryId: number): Observable<any> {

    const params =
      new HttpParams()
        .set(
          'enquiryId',
          enquiryId.toString()
        );

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetApprovedXEnquiry`,
      {
        params
      }
    );
  }


  saveXEnquiryRegistration(
    enquiryId: number,
    registrationData: any
  ): Observable<number> {

    const request = {

      enquiryId:
        enquiryId,

      registrationBody:
        JSON.stringify(
          registrationData
        )
    };


    return this.http.post<number>(
      `${ApiConfig.baseUrl}/admin/SaveXEnquiryRegistration`,
      request
    );
  }


  SaveXBookingRegistration(
    enquiryId: number,
    registrationData: any
  ): Observable<number> {

    const request = {

      enquiryId:
        enquiryId,

      registrationBody:
        JSON.stringify(
          registrationData
        )
    };


    return this.http.post<number>(
      `${ApiConfig.baseUrl}/admin/SaveXBookingRegistration`,
      request
    );
  }

  getXSiteLocations(
    action: string = 'GET_ACTIVE',
    id: number = 0
  ): Observable<any[]> {

    const params =
      new HttpParams()
        .set(
          'action',
          action
        )
        .set(
          'id',
          id.toString()
        );

    return this.http.get<any[]>(
      `${ApiConfig.baseUrl}/admin/GetXSiteLocations`,
      {
        params
      }
    );
  }


  // Get full VOC details by Id.
  getXVOCFullDetails(vocId: number): Observable<any> {

    const params = new HttpParams()
      .set('vocId', vocId.toString());

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXVOCFullDetails`,
      { params }
    );
  }


  //Set X VOC
  SetXVOC(model: any, type: string): Observable<any> {

    const params = new HttpParams()
      .set('type', type);

    return this.http.post<any>(
      `${ApiConfig.baseUrl}/admin/SetXVOC`,
      model,
      { params }
    );
  }


  // Get full VOC details by Id.
  GetXParticipantDetails(Id: number, ParticipantId: number, type: string): Observable<any> {

    const params = new HttpParams()
      .set('Id', Id.toString()).set('ParticipantId', ParticipantId.toString()).set('type', type.toString());

    return this.http.get<any>(
      `${ApiConfig.baseUrl}/admin/GetXParticipantDetails`,
      { params }
    );
  }

  //get Home Course Content
  getHomeCourseContent(): Observable<HomeCourseContentModel[]> {
    return this.http.get<HomeCourseContentModel[]>(`${ApiConfig.baseUrl}/admin/GetHomeCourseContent`, {

    });
  }

  //update Home Course Content
  updateHomeCourseContent(model: HomeCourseContentModel): Observable<string> {
    return this.http.post(
      `${ApiConfig.baseUrl}/admin/UpdateHomeCourseContent`,
      model,
      { responseType: 'text' }
    );
  }


  //get States Service
  getStatesService(action: string): Observable<StateModel[]> {
    const params = new HttpParams()
      .set('action', action.toString());
    return this.http.get<StateModel[]>(`${ApiConfig.baseUrl}/admin/GetStates`, { params });
  }


 //get Course Download
getCourseDownload(
  action: string = 'ALL',
  includeShortDescription: boolean = true,
  includeDescription: boolean = true
): Observable<CourseDownloadModel[]> {

  const params = new HttpParams()
    .set('action', action)
    .set('includeShortDescription', includeShortDescription.toString())
    .set('includeDescription', includeDescription.toString());

  return this.http.get<CourseDownloadModel[]>(
    `${ApiConfig.baseUrl}/admin/GetCourseDownload`,
    { params }
  );
}

}
